import React = require('react');
import LinearProgress from "material-ui/LinearProgress";

import l10n from 'diy/util/l10n';

interface RunningViewProps extends React.Props<RunningView> {
    websiteUrl: string;
}

export default class RunningView extends React.Component<RunningViewProps, any> {

    render() {
        return (
            <div>
                <div className="transfer-dialog-container">
                    <h3 className="transfer-dialog-running-title">
                        {l10n("migration.transfer.running.title")}
                    </h3>
                    <div className="transfer-dialog-description">
                        {l10n("migration.transfer.running.description")}
                    </div>
                    <div className="transfer-dialog-linear-progress">
                        <LinearProgress mode="indeterminate" style={{backgroundColor: "#baddfa"}} />
                    </div>
                </div>
                <div className="transfer-dialog-footer" dangerouslySetInnerHTML={{__html:
                    l10n("migration.transfer.footer").replace(
                        "{link}",
                        `<a href=${this.props.websiteUrl} target="_blank">
                            ${this.props.websiteUrl}
                        </a>`
                    )
                }}>
                </div>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/externalwebsiteimport/transferDialog/views/RunningView.tsx
 **/